<template>
  <div style="padding:0 10px">
    <Table
      :columns="tableColumns"
      :data="tableData.data"
      :loading="tableLoading"
      style="margin:10px 0;"
    >
      <template slot-scope="{ row }" slot="restrict_begin_time">
        {{ row.restrict_begin_time }}—{{ row.restrict_end_time }}
      </template>
      <template slot-scope="{ row }" slot="total_score">
        <span v-if="row.is_can_see_score == 1">{{
          row.exam_info.total_score
        }}</span>
        <span v-else>-</span>
      </template>
      <template slot-scope="{ row }" slot="status">
        <span v-if="row.exam_info">{{
          row.exam_info.status == 3 ? "成功交卷" : "未交卷"
        }}</span>
      </template>
      <template slot-scope="{ row }" slot="exam_score">
        <span>{{ row.exam_info.exam_score }}</span>
      </template>
      <template slot-scope="{ row }" slot="action">
        <Button
          type="info"
          size="small"
          v-if="row.is_can_see_exam == 1"
          @click="seeDetail(row)"
          >查看试卷</Button
        >
      </template>
    </Table>
    <Page
      style="text-align:right;"
      :total="tableData.total"
      :page-size="tableData.per_page"
      :current="tableData.current_page"
      show-total
      @on-change="getData"
    />
  </div>
</template>
<script>
import indexPage from "../../mixins/indexPage";
export default {
  data() {
    return {
      searchData: {
        exam_status: 2,
        grade_id: "",
        subject_id: ""
      },
      tableColumns: [
        { title: "考试名称", key: "name", align: "center", minWidth: 120 },
        {
          title: "考试时间",
          slot: "restrict_begin_time",
          minWidth: 120,
          align: "center"
        },
        { title: "状态", slot: "status", align: "center", minWidth: 120 },
        {
          title: "考试总分",
          key: "total_score",
          align: "center",
          minWidth: 120
        },
        {
          title: "我的得分",
          slot: "total_score",
          align: "center",
          minWidth: 120
        },
        { title: "操作", slot: "action", minWidth: 60, align: "center" }
      ],
      indexUrl: "/app/examination/index"
    };
  },
  mixins: [indexPage],
  props: {
    reSearch: {
      type: Object,
      default: () => ({
        name: ""
      })
    }
  },
  methods: {
    search() {
      if (this.reSearch) {
        this.searchData.name = this.reSearch.name;
        this.searchData.grade_id = this.reSearch.grade_id;
        this.searchData.subject_id = this.reSearch.subject_id;
      }
      this.$forceUpdate();
    },
    seeDetail(row) {
      this.$router.push({
        path: "myExam/historyDetail",
        query: { id: row.id, type: row.type, is_free: row.is_free }
      });
    }
  }
};
</script>
<style scoped>
.group-name:nth-child(n + 2)::before {
  content: " / ";
}
</style>
